/* VALLENCE · Carrito lateral v2 (tema v10 "carrito rápido", 29-oct)
 *
 * Qué cambia frente a v1:
 *  1. Respuesta inmediata: al tocar "Agregar al carrito" (botón principal o barra fija) el botón pasa a "cargando" (spinner, desactivado)
 *     en el mismo toque y el carrito lateral se abre ya, con un esqueleto del producto que se llena cuando llega la respuesta.
 *  2. Un solo pedido: /cart/add.js y /cart/change.js piden la sección (sections=vl-cart-drawer) y devuelven el HTML del carrito
 *     en la misma respuesta. Ya no hay un segundo pedido a /?sections=... (solo queda como respaldo si la respuesta no trae la sección).
 *  3. El pedido sale en el click (antes salía en el evento submit, ~150 ms después con los scripts de terceros corriendo).
 *  4. Icono "Tu carrito" del encabezado: abre al instante con el contenido que ya está en la página y se sincroniza en segundo plano.
 *     Toques repetidos mientras carga se ignoran.
 *  5. "Finalizar compra": estado de carga inmediato, toques dobles ignorados y preconexión a pay.securepago.com (Wiio).
 *     El flujo de la Wiio (NySnippet) no se toca: sigue capturando el botón; si aún no lo capturó, se usa window.nyClick().
 * No quita ni cambia GA4, Meta Pixel, Clarity ni el NySnippet: los pedidos a /cart/add.js usan fetch como antes, así que el pixel
 * de Shopify (web pixels) los sigue detectando.
 */
(function () {
  if (window.__vlcd2) return;
  window.__vlcd2 = true;

  var SECTION = 'vl-cart-drawer';
  var WIIO = 'https://pay.securepago.com';
  var pending = false;   // agregar / cambiar cantidad en curso
  var syncing = false;   // sincronización en segundo plano al abrir desde el encabezado
  var leaving = false;   // "Finalizar compra" ya tocado
  var lastWarm = 0;
  var warmLinks = [];

  function root() { return document.querySelector('[data-vlcd]'); }
  function panel() { return document.querySelector('.vlcd__panel'); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  // Preconexión a la Wiio: la conexión TLS ya está lista cuando se toca "Finalizar compra" (el navegador cierra las inactivas a los pocos segundos,
  // por eso se renueva cada vez que se abre el carrito con productos).
  function warm() {
    var now = Date.now();
    if (now - lastWarm < 8000) return;
    lastWarm = now;
    warmLinks.forEach(function (l) { if (l.parentNode) l.parentNode.removeChild(l); });
    warmLinks = [];
    [false, true].forEach(function (cors) {
      var l = document.createElement('link');
      l.rel = 'preconnect'; l.href = WIIO;
      if (cors) l.crossOrigin = 'anonymous';
      document.head.appendChild(l); warmLinks.push(l);
    });
  }

  function open() {
    var r = root(); if (!r) return false;
    r.classList.add('is-open'); r.setAttribute('aria-hidden', 'false');
    document.body.classList.add('vlcd-lock');
    var p = panel();
    if (p) {
      p.focus({ preventScroll: true });
      if ((parseInt(p.getAttribute('data-count'), 10) || 0) > 0) warm();
    }
    return true;
  }
  function close() {
    var r = root(); if (!r) return;
    r.classList.remove('is-open'); r.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('vlcd-lock');
  }

  function updateBubble(count) {
    var link = document.querySelector('.va-header__cart');
    if (!link) return;
    var small = link.querySelector('small');
    if (count > 0) {
      if (!small) { small = document.createElement('small'); link.appendChild(small); }
      small.textContent = count;
    } else if (small) { small.remove(); }
  }

  // Pone en el carrito el HTML de la sección (de la respuesta de add/change o de /?sections=). Si es igual al actual no toca el DOM.
  function apply(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html || '';
    var np = tmp.querySelector('.vlcd__panel'), op = panel();
    if (!np || !op) return false;
    if (op.innerHTML !== np.innerHTML) op.innerHTML = np.innerHTML;
    var c = parseInt(np.getAttribute('data-count'), 10) || 0;
    op.setAttribute('data-count', c);
    op.removeAttribute('aria-busy');
    updateBubble(c);
    return true;
  }

  function parse(r) {
    return r.json().then(function (d) { return { ok: r.ok, status: r.status, d: d }; }, function () { return { ok: r.ok, status: r.status, d: null }; });
  }

  // Respaldo / sincronización: pide la sección sola.
  function refresh() {
    return fetch('/?sections=' + SECTION + '&_=' + Date.now(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (json) { apply(json[SECTION] || ''); });
  }

  function showError(msg) {
    var s = document.querySelector('.vlcd__scroll'); if (!s) return;
    var e = document.createElement('p');
    e.style.cssText = 'background:#fdecea;color:#8a2a1f;border-radius:10px;padding:10px 12px;font-size:13px;margin:0 0 10px';
    e.textContent = msg; s.insertBefore(e, s.firstChild);
    setTimeout(function () { e.remove(); }, 5000);
  }

  // ---- Estado "cargando" de los botones ----
  function setLoading(els, on) {
    els.forEach(function (el) {
      if (!el) return;
      el.classList.toggle('is-loading', on);
      if (on) {
        el.setAttribute('aria-busy', 'true');
        if (el.tagName === 'BUTTON' || el.tagName === 'INPUT') { el.setAttribute('data-vl-was-disabled', el.disabled ? '1' : '0'); el.disabled = true; }
      } else {
        el.removeAttribute('aria-busy');
        if ((el.tagName === 'BUTTON' || el.tagName === 'INPUT') && el.getAttribute('data-vl-was-disabled') === '0') el.disabled = false;
        el.removeAttribute('data-vl-was-disabled');
      }
    });
  }

  // ---- Esqueleto del producto mientras llega la respuesta ----
  function productInfo() {
    var img = document.querySelector('.product-gallery__image');
    var title = document.querySelector('.product-meta__title');
    return {
      img: img ? (img.currentSrc || img.getAttribute('src') || '') : '',
      title: title ? (title.textContent || '').replace(/\s+/g, ' ').trim() : ''
    };
  }
  function skelItem(info) {
    var img = info && info.img
      ? '<img src="' + esc(info.img) + '" alt="" width="84" height="84">'
      : '<span class="vlcd-skel vlcd-skel--fill"></span>';
    var title = info && info.title
      ? '<span class="vlcd-item__title">' + esc(info.title) + '</span>'
      : '<span class="vlcd-skel" style="width:75%"></span>';
    return '<li class="vlcd-item is-skel" aria-hidden="true"><span class="vlcd-item__img">' + img + '</span>' +
      '<div class="vlcd-item__info">' + title + '<span class="vlcd-skel" style="width:42%"></span><span class="vlcd-skel" style="width:58%;height:34px"></span></div></li>';
  }
  function showSkeleton(info) {
    var p = panel(); if (!p) return;
    p.setAttribute('aria-busy', 'true');
    var ul = p.querySelector('.vlcd-items');
    if (ul) {
      ul.insertAdjacentHTML('afterbegin', skelItem(info));
    } else {
      var empty = p.querySelector('.vlcd-empty');
      var html = '<ul class="vlcd-items">' + skelItem(info) + '</ul>';
      if (empty) empty.outerHTML = html;
      else { var s = p.querySelector('.vlcd__scroll'); if (s) s.insertAdjacentHTML('beforeend', html); }
    }
    if (!p.querySelector('.vlcd__footer')) {
      p.insertAdjacentHTML('beforeend', '<footer class="vlcd__footer is-skel" aria-hidden="true"><span class="vlcd-skel" style="width:100%;height:16px;margin:4px 0 12px"></span><span class="vlcd-skel" style="width:100%;height:52px;border-radius:12px"></span></footer>');
    }
  }

  // ---- Agregar ----
  function doAdd(req, btns, optimistic) {
    if (pending) return Promise.resolve();
    pending = true;
    var r = root();
    setLoading(btns, true);
    var backup = null;
    if (r) r.classList.add('is-adding');
    if (optimistic) {
      var p = panel(); backup = p ? p.innerHTML : null;
      showSkeleton(productInfo());
      open();
    }
    var opts = {
      method: 'POST', credentials: 'same-origin',
      headers: req.json ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: req.json ? JSON.stringify(req.body) : req.body
    };
    return fetch('/cart/add.js', opts).then(parse).then(function (res) {
      var html = res.d && res.d.sections && res.d.sections[SECTION];
      if (res.ok) {
        if (html && apply(html)) return;
        return refresh();                       // respaldo: la respuesta no trajo la sección
      }
      var p2 = panel(); if (backup !== null && p2) { p2.innerHTML = backup; p2.removeAttribute('aria-busy'); }
      open();
      showError((res.d && (res.d.description || res.d.message)) || 'No pudimos agregar el producto.');
    }).catch(function () {
      var p3 = panel(); if (backup !== null && p3) { p3.innerHTML = backup; p3.removeAttribute('aria-busy'); }
      open();
      showError('No pudimos agregar el producto. Intenta de nuevo.');
    }).then(function () {
      pending = false;
      setLoading(btns, false);
      if (r) { r.classList.remove('is-adding'); r.classList.remove('is-busy'); }
    });
  }

  function addFromForm(form, btns) {
    var fd = new FormData(form);
    if (!fd.get('quantity')) fd.append('quantity', '1');
    fd.append('sections', SECTION);
    fd.append('sections_url', '/');
    return doAdd({ body: fd, json: false }, btns, true);
  }

  // ---- Cambiar cantidad / quitar ----
  function change(line, qty) {
    if (pending || syncing) return;
    pending = true;
    var r = root(); if (r) r.classList.add('is-busy');
    fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: SECTION, sections_url: '/' })
    }).then(parse).then(function (res) {
      var html = res.d && res.d.sections && res.d.sections[SECTION];
      if (res.ok && html && apply(html)) return;
      return refresh();
    }).catch(function () { showError('No pudimos actualizar tu carrito. Intenta de nuevo.'); })
      .then(function () { pending = false; if (r) r.classList.remove('is-busy'); });
  }

  // ---- Abrir desde el encabezado: al instante, con lo que ya está en la página ----
  function openFromHeader() {
    open();
    if (syncing || pending) return;
    syncing = true;
    var r = root(); if (r) r.classList.add('is-sync');
    refresh().catch(function () {}).then(function () { syncing = false; if (r) r.classList.remove('is-sync'); });
  }

  // ---- Finalizar compra ----
  function resetCheckout() {
    leaving = false;
    var bs = document.querySelectorAll('.vlcd__btn--checkout.is-loading');
    for (var i = 0; i < bs.length; i++) { bs[i].classList.remove('is-loading'); bs[i].removeAttribute('aria-busy'); }
  }
  function onCheckoutClick(e, b) {
    if (leaving) { e.preventDefault(); e.stopImmediatePropagation(); return; }   // toque doble
    leaving = true;
    b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true');
    setTimeout(resetCheckout, 12000);   // red de seguridad si la Wiio no responde: el cliente puede volver a tocar
    // "Finalizar compra" tocado antes de que el NySnippet tome el botón nuevo (pasa justo después de actualizar el carrito):
    // window.nyClick lleva al checkout de la Wiio con el carrito actual. Sin NySnippet, sigue el envío normal.
    if (b.getAttribute('data-ny-bound') !== '1' && typeof window.nyClick === 'function') {
      e.preventDefault(); e.stopImmediatePropagation();
      window.nyClick();
    }
  }

  // Un solo "click" en captura (se ejecuta antes que los scripts de terceros y que el NySnippet)
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var cb = t.closest('.vlcd__btn--checkout');
    if (cb) { onCheckoutClick(e, cb); return; }

    // Dentro del carrito lateral
    if (t.closest('[data-vlcd-close]')) { close(); return; }
    var q = t.closest('[data-vlcd-qty]');
    if (q) {
      var li = q.closest('.vlcd-item');
      if (li) change(parseInt(li.getAttribute('data-line'), 10), parseInt(q.getAttribute('data-vlcd-qty'), 10));
      return;
    }
    var a = t.closest('[data-vlcd-add]');
    if (a) {
      if (!pending) doAdd({ body: { id: parseInt(a.getAttribute('data-vlcd-add'), 10), quantity: 1, sections: SECTION, sections_url: '/' }, json: true }, [a], false);
      return;
    }
    if (t.closest('.vlcd')) return;

    // "Agregar al carrito": botón principal de la página de producto y barra fija
    var sticky = t.closest('[data-vl-stk-btn]');
    var sub = sticky ? null : t.closest('form[action*="/cart/add"] button, form[action*="/cart/add"] input[type="submit"]');
    if (sticky || sub) {
      var form = sticky ? document.querySelector('form.product-form[action*="/cart/add"], .product-form__payment-container form[action*="/cart/add"]') : (sub.form || sub.closest('form'));
      if (!form || !root()) return;
      if (!sticky && sub.type && sub.type !== 'submit') return;
      if (pending) { e.preventDefault(); return; }   // toque repetido (incluye el clic que la barra fija le pasa al botón principal); sin stopImmediatePropagation para que Meta/Clarity vean el clic igual que antes
      if (form.checkValidity && !form.checkValidity()) return;                       // deja la validación normal del navegador
      e.preventDefault();
      var main = document.getElementById('AddToCart');
      addFromForm(form, sticky ? [sticky, main] : [sub, document.querySelector('[data-vl-stk-btn]')]);
      return;
    }

    // Icono "Tu carrito" del encabezado (en /cart se queda la página)
    var link = t.closest('a[href="/cart"], a[href$="/cart"]');
    if (link && location.pathname.replace(/\/$/, '') !== '/cart' && root()) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault();
      var r = root();
      if (r.classList.contains('is-open')) return;   // toque repetido
      openFromHeader();
    }
  }, true);

  // Respaldo: envío del formulario sin pasar por el click (Enter, requestSubmit de otro script)
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute) return;
    var action = f.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1 || f.closest('.vlcd') || !root()) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (pending) return;
    addFromForm(f, [document.getElementById('AddToCart'), document.querySelector('[data-vl-stk-btn]')]);
  }, true);

  // Activa :active en iOS (el estado "presionado" se ve en el mismo toque)
  document.addEventListener('touchstart', function () {}, { passive: true });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  window.addEventListener('pageshow', function (ev) { if (ev.persisted && root()) { resetCheckout(); refresh().catch(function () {}); } });
  window.vlCartDrawer = { open: open, close: close, refresh: refresh };
})();
